<div class="main-content">
    <div class="terms-container">
        <h1 class="text-center mb-4" translate>pages.Termsconditions.Termsconditions</h1>
        <iframe src="https://imageblobs.blob.core.windows.net/webpage/terms_conditions.pdf" type="application/pdf"
            frameBorder="0" scrolling="auto" height="900px" width="100%"></iframe>
    </div>
</div>